import { ReactNode, useMemo } from 'react'
import { OnboardingFlowContext, OnboardingFlowContextType, OnboardingFlowType } from './OnboardingFlowContext'

interface OnboardingFlowProviderProps {
    children: ReactNode
    flowType: OnboardingFlowType
}

export function OnboardingFlowProvider({ children, flowType }: OnboardingFlowProviderProps) {
    const value = useMemo<OnboardingFlowContextType>(
        () => ({
            flowType,
        }),
        [flowType],
    )

    return <OnboardingFlowContext.Provider value={value}>{children}</OnboardingFlowContext.Provider>
}
